export const defaultBusinessConceptDescriptorPaths = [
  'tags.tagFQN',
  'dataContract.schema.tags.tagFQN',
  'businessConcepts.tagFQN',
  'dataContract.schema.businessConcepts.tagFQN',
];

export function isIri(value: string): boolean {
  if (
    !/^https?:\/\/[^/?#]+/i.test(value) ||
    /[\s\p{Cc}\p{Cs}<>"{}|\\^`]/u.test(value) ||
    /%(?![\da-f]{2})/i.test(value)
  )
    return false;
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && !!url.hostname;
  } catch {
    return false;
  }
}

export function classifyBusinessConceptValue(
  value: string,
  enforceIri = false,
): 'iri' | 'label' {
  return enforceIri || isIri(value) ? 'iri' : 'label';
}
